"use strict";
/**
 * Created on 09 18 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>Immutable implementation of {@link PriceTerminationItemPriceValidToPartial}</p>
 * <p>The main purpose of this representation is to provide capability of PATCH request related to the entire entity.</p>
 *
 * @author JMe
 */


var PriceTerminationItemPriceValidTo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceTerminationItemPriceValidTo, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link PriceTerminationItem.id}.
   * @param pValidTo Corresponds to {@link PriceTerminationItem.pValidTo}.
   */
  function PriceTerminationItemPriceValidTo(id, pValidTo) {
    var _this;

    _classCallCheck(this, PriceTerminationItemPriceValidTo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceTerminationItemPriceValidTo).call(this));
    _this.id = id;
    _this.pValidTo = pValidTo;
    return _this;
  }

  return PriceTerminationItemPriceValidTo;
}(DomainObject_1.DomainObject);

exports.PriceTerminationItemPriceValidTo = PriceTerminationItemPriceValidTo;
/**
 * <p>Immutable implementation of {@link PriceTerminationItemTerminatePartial}</p>
 * <p>The main purpose of this representation is to provide capability of PATCH request related to the entire entity.</p>
 *
 * @author JMe
 */

var PriceTerminationItemTerminate =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(PriceTerminationItemTerminate, _DomainObject_1$Domai2);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link PriceTerminationItem.id}.
   * @param terminate Corresponds to {@link PriceTerminationItem.terminate}.
   */
  function PriceTerminationItemTerminate(id, terminate) {
    var _this2;

    _classCallCheck(this, PriceTerminationItemTerminate);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PriceTerminationItemTerminate).call(this));
    _this2.id = id;
    _this2.terminate = terminate;
    return _this2;
  }

  return PriceTerminationItemTerminate;
}(DomainObject_1.DomainObject);

exports.PriceTerminationItemTerminate = PriceTerminationItemTerminate;